import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';

import Button from 'src/app/components/Elements/Button';
import { Card, CardItem } from 'src/app/components/Elements/Card';
import { FocusLockAndEscape } from 'src/app/components/PageSections/CardItemOverflowMenuWrapper/FocusLockAndEscape';

import { CloseModalButton } from '../CloseModalButton';

import styles from './styles.module.scss';

const Renderer = ({ dispatchCloseModal, handleConfirmClick, confirmMessage }) => {
  const confirmDialogLabel = 'confirm_dialog_label';
  return (
    <div role="dialog" aria-modal="true" aria-labelledby={confirmDialogLabel} className={styles.component}>
      <FocusLockAndEscape handleEscapePressed={dispatchCloseModal}>
        <Card>
          <CardItem>
            <CloseModalButton onClick={dispatchCloseModal} />
            <Container>
              <Row>
                <Col>
                  <h3 role="status" id={confirmDialogLabel}>
                    {confirmMessage}
                  </h3>
                </Col>
              </Row>
              <div className={styles.buttonContainer}>
                <Button style="secondary" size="small" fixedWidth onClick={handleConfirmClick}>
                  YES
                </Button>
                <Button style="secondary" size="small" fixedWidth onClick={dispatchCloseModal}>
                  NO
                </Button>
              </div>
            </Container>
          </CardItem>
        </Card>
      </FocusLockAndEscape>
    </div>
  );
};

Renderer.defaultProps = {
  handleConfirmClick: noop,
};

Renderer.propTypes = {
  handleConfirmClick: PropTypes.func.isRequired,
  confirmMessage: PropTypes.string.isRequired,
  dispatchCloseModal: PropTypes.func.isRequired,
};

export default Renderer;
